const scoreboardBtn = document.querySelector(".button");
const accordionTab = document.querySelectorAll(".accordion__tabLink");
const accordionTabInnerHead = document.querySelectorAll(".accordion__tabInnerLinkHead");
// const accordionTabInner = document.querySelectorAll(".accordion__tabInnerLink");
const wrapper = document.querySelector(".wrapper");

scoreboardBtn.addEventListener("click", function () {
    scoreboardBtn.classList.toggle("button--collapsed");
    wrapper.classList.toggle("isCollapsed");
});

accordionTab.forEach((tab) => {
    tab.addEventListener("click", function (e) {
        e.stopPropagation();
        tab.closest(".accordion__tab").classList.toggle("accordion__tab--open");
    });
});

accordionTabInnerHead.forEach((tab) => {
    tab.addEventListener("click", function (e) {
        e.stopPropagation();
        tab.closest(".accordion__tabInnerLink").classList.toggle("accordion__tabInnerLink--close");
    });
});
